export const SHOW_CHARACTER_SHEET = "show-character-sheet";
